import {
    TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING,
    TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS,
    TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE
} from './actionTypes';

const initialState = {
    loading: false,
    totais: {
        precipitacaoTotal: 0,
        temperaturaMedia: 0,
        umidadeMedia: 0,
        diasChuva: 0,
        pressaoMedia: 0
    },
    graficos: {
        precipitacaoDiaria: null,
        umidadeRelativa: null,
        pressaoAtmosferica: null,
        variacaoTemperatura: null
    }
}

function dashboardPluviometroReducer(state = initialState, action) {
    switch (action.type) {
        case TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING:
            return {
                ...state,
                loading: true
            }
        case TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS:
            return {
                ...state,
                loading: false,
                totais: action.totais || state.totais,
                graficos: action.graficos || state.graficos
            }
        case TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE:
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

export { dashboardPluviometroReducer };
